import { writable } from 'svelte/store';

export const soundVolume = writable(0);

export const isLeftHandedUI = writable(0);

const appSetUp = () => {
    let url;
    let skin;
    function setUrl(value) {
        url = value
    }
    function getUrl() {
        return url
    }

    function setSkin(value) {
        skin = value
    }
    function getSkin() {
        return skin
    }

    return { setUrl, getUrl, setSkin, getSkin }
}

export const appSettings = appSetUp();

export const setHost = () => {
    try {
        let url = document.currentScript.src
        let arr = url.split("\/")
        arr.pop()
        url = arr.join("\/")
        appSettings.setUrl(url)
    } catch {
        console.log("can't access in main")
    }
}
